'use strict';

const { h } = require('phy');
const { Translate, WithI18n } = require('@grpn/preact-l10n');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const CouponsList = require('../../coupons/views/coupons-list');
const Carousel = require('../../shared/views/carousel');
const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');
const SidebarBrowseMerchant = require('../../merchant/views/sidebar-browse-merchant');
const SidebarBrowseAtoz = require('../../merchant/views/sidebar-browse-atoz');
const EmailSubscription = require('../../email_subscription/views/email-subscription');
const Breadcrumbs = require('../../../components/breadcrumbs');
const LeaderboardBannerWrapper = require('../../../components/leaderboard_banner');

const localisationParser = require('../../support/localisation-parser');
const { groupPremiumOffers } = require('../../support/premium-offers-helper');
const { pruneData } = require('../../support/prune-data');

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-sidebar',
    coupons,
    autoplay: true,
    navigation: false,
    options: {
      perPage: 1,
    },
  };
}

function getCategoryDescription(category) {
  return h(WithI18n, {}, i18n =>
    h('.category-offers-description', {
      dangerouslySetInnerHTML: {
        __html: localisationParser.parse(
          i18n.t(`modules.category.Description.${category}`)
        ),
      },
    })
  );
}

function CategoryOffers({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    category,
    premiumOffers,
    couponsForList,
    categoryMerchants,
    advertsForCarousel,
    leaderboardAdverts,
    relatedMerchants,
    relatedCategories,
  } = payload;
  const {
    routes,
    csrfToken,
    showUberOffer,
    showLeaderboardBanner,
    isTouch,
    breadcrumbList,
  } = deps;

  const { premiumList, couponList } = groupPremiumOffers(
    premiumOffers.concat(couponsForList)
  );

  const leaderboardBanner = LeaderboardBannerWrapper({
    show: showLeaderboardBanner,
    adverts: leaderboardAdverts,
    isTouch,
    outerClassName: 'category-offers-section',
    routes: pruneData(routes, 'merchant:show'),
  });

  return h('article', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: `modules.category.Name.${category}`,
    }),
    h('section.container', [
      Breadcrumbs(breadcrumbList),
      h('.layout', [
        h(
          '.layout-content',
          {
            'data-bhw': 'CategoryCouponsList',
          },
          [
            h(
              '.category-offers-section',
              h(CouponsList, {
                premium: premiumList,
                coupons: couponList,
                routes,
                isTouch,
                showUberOffer,
                related: {
                  parentCategory: category,
                  categories: relatedCategories,
                  merchants: relatedMerchants,
                },
              })
            ),
            !isTouch && leaderboardBanner,
          ]
        ),
        h('.layout-sidebar', [
          advertsForCarousel &&
            advertsForCarousel.length > 0 &&
            h(
              '.carousel-container',
              Carousel({ routes, ...getCarouselOptions(advertsForCarousel) })
            ),
          h('.category-offers-section', [
            h('h3.category-offers-heading', [
              h(
                Translate,
                { attrs: { class: 'category-offers-about' } },
                'modules.category.About'
              ),
              h(Translate, `modules.category.Name.${category}`),
            ]),
            getCategoryDescription(category),
          ]),
          h(
            '.category-offers-section',
            SidebarBrowseAtoz({
              routes: pruneData(routes, 'all_brands:main'),
              bhcName: `categoryBrowseByAtoz:${category}`,
            })
          ),
          isTouch && leaderboardBanner,
          EmailSubscription({
            csrfToken,
            routes,
            classNames: {
              outer: 'category-offers-section',
            },
            bhwName: `CategoryEmailSubscription:${category}`,
          }),
          h(
            '.category-offers-section',
            {
              'data-bhw': 'CategoryBrowseByStore',
            },
            h(SidebarBrowseLetter, { routes })
          ),
          categoryMerchants.length > 0 &&
            h(SidebarBrowseMerchant, {
              routes,
              className: '.category-offers-section',
              merchants: categoryMerchants,
              localisation: {
                resource: 'modules.shared.TopBrands',
                data: { tag: 'h3', attrs: { class: 'sidebar-browse-title' } },
              },
            }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = CategoryOffers;
